<template>
  <div>
    <v-expansion-panels
      v-if="hiringConpanies.length > 1"
      v-model="group"
      accordion
      multiple
    >
      <v-expansion-panel
        v-for="(item, i) in companiesItems"
        :key="`company_${i}`"
      >
        <v-expansion-panel-header
          class="d-flex hover:tw-bg-bg-2 !tw-rounded-lg tw-relative"
        >
          <div
            class="tw-h-full tw-w-1 tw-bg-gray-300 tw-absolute tw-top-0 tw-left-4"
          >
            <div
              v-if="group.includes(i)"
              class="tw-h-4 tw-w-full tw-absolute tw-top-1/2 tw-left-0 -tw-translate-y-1/2 tw-bg-purple-600"
            ></div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div class="tw-pl-[28px]">
              <Typography
                :variant="group.includes(i) ? 'subtitle-2' : 'body-2'"
              >
                {{ item.hiring_company }} ({{ item.projects?.length }})
              </Typography>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list-item-group>
            <div
              v-for="(project, index) in item.projects"
              :key="index"
              class="position-relative hover:tw-bg-bg-2 !tw-pl-10 !tw-rounded-lg"
            >
              <div
                class="tw-h-full tw-w-1 tw-bg-gray-300 tw-absolute tw-top-0 tw-left-[37px]"
              >
                <div
                  v-if="projectId === project.project_id"
                  class="tw-h-4 tw-w-full tw-absolute tw-top-1/2 tw-left-0 -tw-translate-y-1/2 tw-bg-purple-600"
                ></div>
              </div>
              <v-list-item
                class="list-item in-auto-swipe-mode !tw-pr-1"
                :class="{
                  'selected-item tw-font-bold':
                    projectId === project.project_id,
                }"
                @click="onProjectClick(project)"
              >
                <v-list-item-icon class="icon1">
                  <div class="tw-w-4 tw-h-4">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="tw-fill-purple-600"
                      :class="{ '!tw-fill-red-0': project.is_peq }"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.9572 19.9326C10.5979 15.5108 8.02575 11.7147 4.34973 9.65324C4.12235 10.3954 4 11.1834 4 12C4 16.0648 7.03161 19.4216 10.9572 19.9326ZM5.40215 7.47447C6.84423 5.37606 9.26142 4 12 4C14.7388 4 17.1561 5.37623 18.5981 7.47486C16.6071 8.45155 14.3678 8.99995 12.0005 8.99995C9.63289 8.99995 7.39338 8.45141 5.40215 7.47447ZM20.3352 6.47314C18.5439 3.77708 15.4795 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.8837 21.8171 9.81007 21.4796 8.80753C21.4797 8.80747 21.4799 8.8074 21.4801 8.80734C21.1998 7.97476 20.8129 7.19119 20.3356 6.47285C20.3355 6.47295 20.3353 6.47304 20.3352 6.47314ZM19.6504 9.65365C15.9748 11.7152 13.403 15.511 13.0437 19.9325C16.9688 19.4211 20 16.0645 20 12C20 11.1835 19.8777 10.3957 19.6504 9.65365ZM14.0005 11.9999C14.0005 13.1044 13.1051 13.9999 12.0005 13.9999C10.896 13.9999 10.0005 13.1044 10.0005 11.9999C10.0005 10.8953 10.896 9.99985 12.0005 9.99985C13.1051 9.99985 14.0005 10.8953 14.0005 11.9999Z"
                      />
                    </svg>
                  </div>
                </v-list-item-icon>
                <v-list-item-title>
                  <TitleItem
                    :name="project.project_name"
                    :isActive="projectId === project.project_id"
                  />
                </v-list-item-title>
                <v-list-item-action class="project-count child">
                  {{ getCandidateCount(project) }}
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <v-list-item-group>
        <div
          v-for="(project, index) in allProjects"
          :key="index"
          class="position-relative"
        >
          <div
            class="tw-h-full tw-w-1 tw-bg-gray-300 tw-absolute tw-top-0 tw-left-4"
          >
            <div
              v-if="projectId === project.project_id"
              class="tw-h-4 tw-w-full tw-absolute tw-top-1/2 tw-left-0 -tw-translate-y-1/2 tw-bg-purple-600"
            ></div>
          </div>
          <v-list-item
            class="list-item group in-auto-swipe-mode hover:tw-bg-bg-2 !tw-pl-8 !tw-rounded-lg !tw-pr-1"
            :class="{
              'selected-item tw-font-bold': projectId === project.project_id,
            }"
            @click="onProjectClick(project)"
          >
            <v-list-item-icon class="icon1">
              <div class="tw-w-4 tw-h-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-fill-purple-600"
                  :class="{ '!tw-fill-red-0': project.is_peq }"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.9572 19.9326C10.5979 15.5108 8.02575 11.7147 4.34973 9.65324C4.12235 10.3954 4 11.1834 4 12C4 16.0648 7.03161 19.4216 10.9572 19.9326ZM5.40215 7.47447C6.84423 5.37606 9.26142 4 12 4C14.7388 4 17.1561 5.37623 18.5981 7.47486C16.6071 8.45155 14.3678 8.99995 12.0005 8.99995C9.63289 8.99995 7.39338 8.45141 5.40215 7.47447ZM20.3352 6.47314C18.5439 3.77708 15.4795 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.8837 21.8171 9.81007 21.4796 8.80753C21.4797 8.80747 21.4799 8.8074 21.4801 8.80734C21.1998 7.97476 20.8129 7.19119 20.3356 6.47285C20.3355 6.47295 20.3353 6.47304 20.3352 6.47314ZM19.6504 9.65365C15.9748 11.7152 13.403 15.511 13.0437 19.9325C16.9688 19.4211 20 16.0645 20 12C20 11.1835 19.8777 10.3957 19.6504 9.65365ZM14.0005 11.9999C14.0005 13.1044 13.1051 13.9999 12.0005 13.9999C10.896 13.9999 10.0005 13.1044 10.0005 11.9999C10.0005 10.8953 10.896 9.99985 12.0005 9.99985C13.1051 9.99985 14.0005 10.8953 14.0005 11.9999Z"
                  />
                </svg>
              </div>
            </v-list-item-icon>
            <v-list-item-title>
              <TitleItem
                :name="project.project_name"
                :isActive="projectId === project.project_id"
              />
            </v-list-item-title>
            <v-list-item-action>
              <div class="project-count">
                {{ getCandidateCount(project) }}
              </div>
            </v-list-item-action>
          </v-list-item>
        </div>
      </v-list-item-group>
    </div>
  </div>
</template>
<script>
import TitleItem from '@/components/widgets/TitleItem';
import Typography from '@/components/v3/base/Typography';

export default {
  name: 'ProjectGroup',

  components: {
    TitleItem,
    Typography,
  },

  props: {
    companiesItems: {
      type: Array,
      default: () => [],
    },

    projectId: String,
    isActive: Boolean,
  },

  data() {
    return {
      group: [],
    };
  },

  computed: {
    allProjects() {
      const arr = [];
      this.companiesItems.forEach((item) => {
        item.projects.forEach((project) => {
          arr.push(project);
        });
      });
      return arr;
    },

    hiringConpanies() {
      const arr = [];
      this.companiesItems.forEach((item) => {
        item.projects.forEach((project) => {
          if (!arr.includes(project.hiring_company)) {
            arr.push(project.hiring_company);
          }
        });
      });
      return arr;
    },
  },

  watch: {
    companiesItems() {
      if (this.isActive) {
        this.checkGroup();
      }
    },

    hiringConpanies() {
      if (this.isActive) {
        this.checkGroup();
      }
    },

    $route() {
      this.checkGroup();
    },
  },

  mounted() {
    this.checkGroup();
  },

  methods: {
    onProjectClick(project) {
      this.$emit('openProject', project.project_id);
    },

    onSelectProject(project) {
      this.$emit('isShowActions', true);
      this.$emit('openProject', project.project_id);
      this.$emit('triggerProjectId', {
        id: project.project_id,
        name: project.project_name,
        outreach_pause: project.outreach_pause,
        archive: project.is_archived,
      });
      setTimeout(() => {
        this.$emit('getTop');
      }, 0);
    },

    getCountAll(projects) {
      let ind = 0;
      projects.forEach((project) => {
        const i = this.getCandidateCount(project);
        ind += i;
      });
      return ind;
    },

    checkGroup() {
      if (this.hiringConpanies.length > 1) {
        this.group = [];
        this.companiesItems.forEach((item, i) => {
          item.projects.forEach((pro) => {
            if (pro.project_id === this.projectId && !this.group.includes(i)) {
              this.group.push(i);
            }
          });
        });
      }
    },

    getCandidateCount(project) {
      // TODO(jeremiah): clean this up after v2 rollout
      if (project.candidate_batch_count) {
        const isCalibration =
          project.status === '6' ||
          (project.status === '5' &&
            this.$store.getters['user/getIsSuperAdmin']);
        if (project.type === '1') {
          if (this.$store.getters['user/getIsSuperAdmin']) {
            return (
              (isCalibration
                ? project.candidate_batch_count.UNDER_REVIEW || 0
                : project.candidate_batch_count.AUTOPILOT_RECRUITER || 0) +
              (project.candidate_batch_count.QUESTION || 0)
            );
          }
          return isCalibration
            ? project.candidate_batch_count.UNDER_REVIEW || 0
            : project.candidate_batch_count.HIRING_MANAGER || 0;
        }
        if (project.type === '2') {
          return project.candidate_batch_count.UNDER_REVIEW || 0;
        }
        if (project.type === '3') {
          return isCalibration
            ? project.candidate_batch_count.UNDER_REVIEW || 0
            : project.candidate_batch_count.HIRING_MANAGER || 0;
        }
      }
      if (project.in_auto_swipe_mode && project.is_warmleads_recruiter) {
        return (
          (project.candidates_warm_leads_recruiter_count || 0) +
          (project.candidates_warm_leads_question_count || 0)
        );
      }
      if (project.in_auto_swipe_mode && !project.is_warmleads_recruiter) {
        return project.candidates_warm_leads_hm_count || 0;
      }

      return project.candidates_review_count || 0;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './styles';
::v-deep {
  .v-list-item__title {
    font-weight: inherit !important;
  }
}
</style>
